/* @flow */

import _LineGraph from './LineGraph';

export default _LineGraph;



// WEBPACK FOOTER //
// ./src/components/LineGraph/index.js